<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9354_80850)">
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint0_linear_9354_80850)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint1_radial_9354_80850)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint2_radial_9354_80850)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint3_linear_9354_80850)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint4_linear_9354_80850)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint5_linear_9354_80850)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint6_linear_9354_80850)"
      />
      <path d="M14.8401 8.23745C15.7779 8.47126 16.3486 9.42103 16.1148 10.3588L14.8539 15.4163C14.8381 15.4794 14.8859 15.5405 14.9509 15.5405H16.6222C16.6774 15.5405 16.7222 15.4957 16.7222 15.4405V14.4354C16.7222 13.4689 17.5057 12.6854 18.4722 12.6854C19.4387 12.6854 20.2222 13.4689 20.2222 14.4354V15.4941C20.2222 15.5416 20.2557 15.5823 20.3018 15.5939C21.06 15.7859 21.621 16.4727 21.621 17.2905C21.621 18.1083 21.06 18.7951 20.3018 18.9871C20.2557 18.9987 20.2222 19.0394 20.2222 19.0869V22.8149C20.2222 23.7814 19.4387 24.5649 18.4722 24.5649C17.5057 24.5649 16.7222 23.7814 16.7222 22.8149V19.1405C16.7222 19.0853 16.6774 19.0405 16.6222 19.0405H12.583C12.0443 19.0405 11.5357 18.7924 11.204 18.3679C10.8724 17.9434 10.7547 17.3898 10.885 16.8671L12.7187 9.51212C12.9526 8.57433 13.9023 8.00364 14.8401 8.23745Z"
            fill="#FCF2FF"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_9354_80850"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BB3FD" />
        <stop offset="1"
              stop-color="#5194EC"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_9354_80850"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.5 3.5) rotate(135) scale(3.53553 4.12942)"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_9354_80850"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3 29) rotate(-40.6013) scale(4.60977 5.3841)"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_9354_80850"
                      x1="30"
                      y1="16"
                      x2="25.5"
                      y2="16"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.1"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_9354_80850"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="6"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.13"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_9354_80850"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_9354_80850"
                      x1="29.9012"
                      y1="15.7489"
                      x2="2.27791"
                      y2="15.7489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <clipPath id="clip0_9354_80850">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>